// extracted by mini-css-extract-plugin
module.exports = {"component":"ListView_component_3OPJo","list":"ListView_list_2C33l"};